import React, { useMemo } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { Box, Grid, IconButton, Link } from '@material-ui/core';
import { RenderAdvanceFilters } from './RenderAdvanceFilters';
import globals from '../../../../globals/communityGlobals';
import { VisitStatusWithName } from '../../../../enums';

const locale = globals.getArea('advanceFilters');

export default function AdvanceFiltersForm({
  handleCancelledTreatmentInstances,
  advanceFiltersSelectedValue,
  setAdvanceFiltersSelectedValue,
  advanceFilters,
  handleSubmit,
  handleCancel,
  handleClear,
  isDataLoading,
}) {
  const handleAdvanceFiltersChange = filterName => selectedValues => {
    let filteredValues;

    if (Array.isArray(selectedValues)) {
      if (selectedValues.length === 0 || selectedValues[selectedValues.length - 1] === '') {
        filteredValues = [''];
      } else {
        filteredValues = selectedValues.filter(x => x !== '');
        if (filteredValues.length === advanceFilters.find(f => f.name === filterName).optionsLength) {
          filteredValues = [''];
        }
      }
    } else {
      filteredValues = filterName === 'multipleClinicians' ? [selectedValues] : selectedValues;
    }
    if (filterName === 'visitStatus')
      handleCancelledTreatmentInstances(
        filteredValues.includes(VisitStatusWithName.find(v => v.key === 'cancelledVisits').id),
      );

    setAdvanceFiltersSelectedValue(prevValues => ({
      ...prevValues,
      [filterName]: filteredValues,
    }));
  };

  const renderedAdvanceFilters = useMemo(
    () =>
      advanceFilters.map(advanceFilterType => (
        <RenderAdvanceFilters
          key={advanceFilterType.name}
          advanceFilter={advanceFilterType}
          selectedValue={advanceFiltersSelectedValue[advanceFilterType.name]}
          handleAdvanceFiltersChange={handleAdvanceFiltersChange(advanceFilterType.name)}
        />
      )),
    [advanceFilters, advanceFiltersSelectedValue, handleAdvanceFiltersChange],
  );

  return (
    <Grid container className="advance-filter-wrapper">
      {renderedAdvanceFilters}
      <Box style={{ width: '100%' }} display="flex" justifyContent="flex-end">
        <Box pr={3} pt={2}>
          <Link className="cancel-link" onClick={handleCancel}>
            {locale.getMsg('cancel')}
          </Link>
        </Box>
        <Box pr={3} pt={2}>
          <Link className="cancel-link" onClick={handleClear}>
            {locale.getMsg('clear')}
          </Link>
        </Box>
        <Box pr={2} pt={2}>
          <IconButton
            size="small"
            className="search-icon"
            onClick={handleSubmit}
            type="submit"
            disabled={isDataLoading}
          >
            <SearchIcon />
          </IconButton>
        </Box>
      </Box>
    </Grid>
  );
}
